import PropTypes from "prop-types";

const CourseFacilitators = ({
	facilitators
}) => facilitators.map(({ contactInformation, name }, idx) => ( // eslint-disable-next-line react/no-array-index-key
	<p key={idx}>{
		contactInformation?.profileUrl
			? <a href={contactInformation.profileUrl} rel="noreferrer" target="_blank">{name}</a>
			: name
	}</p>
));

CourseFacilitators.propTypes = {
	facilitators: PropTypes.arrayOf(PropTypes.shape({
		contactInformation: PropTypes.shape({
			profileUrl: PropTypes.string
		}),
		name: PropTypes.string
	})).isRequired
};

export default CourseFacilitators;
